<!-- Sometimes label somtimes button 🙃 -->
<script lang="ts">
  type Props = {
    text: string;
    onClick?: (() => void) | undefined;
    type: "info" | "error" | "success" | "disabled";
  };
  const { text, onClick, type }: Props = $props();
</script>

<span
  role={onClick ? "button" : undefined}
  class:hidden={!text}
  class:cursor-pointer={!!onClick}
  onclick={onClick}
  class:bg-green-72={type === "info"}
  class:bg-red-5={type === "error"}
  class:bg-green-45={type === "success"}
  class:bg-grey-20={type === "disabled"}
  class="whitespace-nowrap text-[12px] text-white px-[4px] rounded-[3px] font-semibold"
>{text}</span>
